<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <figure>
        <img src="./assets/img/images/expired.svg" alt="Otp" />
      </figure>
    </div>
    <h1 class="title-copy">{{ "Need personal assistance" | translate }}</h1>
      <div class="margin-bottom mb24 ">
        <div class="assistance acmic margin-top mt16">
        <p class="no-margin-bottom">
          {{ "WE_NEED_ADDITIONAL_INFORMATION" | translate }}
        </p>
          <p>
            {{ "PLEASE_CONTACT_US" | translate }}
          </p>
            <a class="underline mapfre link blue-link" href="tel:18442954500">
              {{ "TELL_NUMBER" | translate}}
            </a>
        </div>
        <div class="col margin-top mt24">
          <mapfre-button
            (click)="backButton()"
            additionalClasses="link-button small-btn blue-link no-margin button-border-red"
            [iconClasses]="'align-middle'"
            [showIconsCustom]="true"            
            [backIcon]="'./assets/img/icons/back-arrow-red.png'"
          >
            {{ "BACK" | translate }}
          </mapfre-button>
        </div>
    </div>  
  </div>
</div>
